import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import StepOneITE from './Step4/StepOneITE';

const MultiStepForm4ITE = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/client-audit-ite");
  };

  return <StepOneITE onBack={handleBack} />;
};

export default MultiStepForm4ITE;
